// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__URSXJ","inputWrap":"styles_inputWrap__19_Hw","input":"styles_input__1GAiB"};